import RouteNames from '../../../../../../app/router/_internals/RouteNames.enum';
export default Object.freeze({
	GENERAL: `${RouteNames.RESOURCE_GROUPS}-general`,
	RESOURCES: `${RouteNames.RESOURCE_GROUPS}-resources`,
	TIME_RANGE: `${RouteNames.RESOURCE_GROUPS}-time-range`,
	PERMISSIONS: `${RouteNames.RESOURCE_GROUPS}-permissions`,
});
